'use client';

import { useEffect, useState } from 'react';

import { isBrowser } from '@/lib/utils';

const PWA_DISMISS_KEY = 'pwa-install-dismissed-until';
const DISMISS_DURATION_MS = 60 * 60 * 1000; // 1 hour

const usePwaDismissalStorage = () => {
  const [dismissedUntil, setDismissedUntil] = useState(() => {
    if (isBrowser()) {
      const storedValue = localStorage.getItem(PWA_DISMISS_KEY);
      return storedValue ? parseInt(storedValue, 10) : 0;
    }
    return 0;
  });

  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    setIsDismissed(dismissedUntil && Date.now() < dismissedUntil);
  }, [dismissedUntil]);

  const dismissForDuration = () => {
    const newDismissedUntil = Date.now() + DISMISS_DURATION_MS;
    if (isBrowser()) {
      localStorage.setItem(PWA_DISMISS_KEY, newDismissedUntil.toString());
    }
    setDismissedUntil(newDismissedUntil);
  };

  return [isDismissed, dismissForDuration];
};

export default usePwaDismissalStorage;
